import moment from "moment";

  export const LanguagesSupported = [
    {
     label: "English",
     value: "en"
   },
  {
     label: "Deutsh",
     value: "du"
   },
  {
     label: "Spanish",
     value: "sp"
   },
   {
     label: "Filipino",
     value: "ph"
   },
   {
     label: "Vietnamese",
     value: "vt"
   },
   {
     label: "Chinese simplified",
     value: "ch"
   },
   {
    label: "Hindi",
    value: "hi"
  }
 ];
 export const allTabs = ['/', '/tab2', '/tab3'];


 export const dashboardPath = "/nomDashboard"
 
 export const autoSaveTime = 10000;

 export const startYear = 2022;
 
//  AAD Integration
export const ACCESS_TOKEN = "accessToken";
export const AD_AUTH_AUTHORITY_URL = "https://login.microsoftonline.com/2e319086-9a26-46a3-865f-615bed576786";//"https://login.microsoftonline.com/providence4.onmicrosoft.com";
export const AD_AUTH_CLIENT_ID = "b4feb769-ff26-4d79-8b48-e0226b741ca0";//"05ea7767-47dc-437e-ab91-be7f1a35315b";
export const AD_AUTH_REDIRECT_URI = window.location.origin;
export const AD_AUTH_SESSION_STORAGE = "sessionStorage";
export const AD_AUTH_SCOPE_READ = "user.read";
export const InstrumentationKey="b842037d-0998-4295-b0da-0c6c3e8554f0";
export const AD_AUTH_SCOPE_JWT = "api://b4feb769-ff26-4d79-8b48-e0226b741ca0/VIA-Nominations";



